/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const CompleteLoginParams = zod.object({
  session_state: zod.string().optional(),
  state: zod.string(),
  code: zod.string(),
});

export type CompleteLoginParams = zod.input<typeof CompleteLoginParams>;
export type CompleteLoginParamsOutput = zod.output<typeof CompleteLoginParams>;
